//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetch } from "@/page/index";
import { Toast } from 'vant'

export default {
  props: {
    fileIds: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      baseFileList: [],
      ids: this.fileIds
    }
  },
  created() {
    this.listBaseFile()
  },
  methods: {
    // 加载附件列表
    listBaseFile() {
      if (!this.ids) {
        return
      }
      let _params = {ids: this.ids}
      fetch.v2ListBaseFile(_params).then(res => {
        if (res.status === 'S' && res.data) {
          this.baseFileList = res.data
        }
      })
    },
    
    // 获取文件图标
    getFileIcon(fileName) {
      if (!fileName) return 'description'
      
      const ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
      const iconMap = {
        // 图片
        '.jpg': 'photo-o',
        '.jpeg': 'photo-o',
        '.png': 'photo-o',
        '.gif': 'photo-o',
        '.bmp': 'photo-o',
        '.webp': 'photo-o',
        // 文档
        '.doc': 'notes-o',
        '.docx': 'notes-o',
        '.xls': 'records-o',
        '.xlsx': 'records-o',
        '.ppt': 'newspaper-o',
        '.pptx': 'newspaper-o',
        '.pdf': 'description',
        // 其他
        '.zip': 'bag-o',
        '.rar': 'bag-o',
        '.txt': 'notes-o'
      }
      
      return iconMap[ext] || 'description'
    },
    
    // 判断是否为图片
    isImageFile(fileName) {
      const imageExts = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp']
      const ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
      return imageExts.includes(ext)
    },
    
    // 格式化文件大小
    formatFileSize(size) {
      if (!size) return ''
      if (size < 1024) return size + ' B'
      if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB'
      return (size / (1024 * 1024)).toFixed(2) + ' MB'
    },
    
    // 处理文件点击
    handleFileClick(file) {
      // 所有文件都询问是否下载
      this.$dialog.confirm({
        title: '下载文件',
        message: `确认下载 ${file.originalFileName}？`
      }).then(() => {
        // 确认下载
        this.downloadFile(file)
      }).catch(() => {
        // 取消
      })
    },
    
    // 下载文件
    downloadFile(file) {
      if (!file.fileUrl) {
        Toast.fail('文件地址无效')
        return
      }
      
      const _link = document.createElement('a')
      _link.download = file.originalFileName
      _link.style.display = 'none'
      _link.target = '_blank'
      _link.href = file.fileUrl
      document.body.appendChild(_link)
      _link.click()
      URL.revokeObjectURL(_link.href)
      document.body.removeChild(_link)
      
      Toast.success('开始下载')
    }
  },
  watch: {
    fileIds: {
      handler() {
        if (this.ids !== this.fileIds) {
          this.ids = this.fileIds
          this.listBaseFile()
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/components/Attachment.vue